<template>
    <div class="p-3 row">
        <input-date-time class="col-12 col-md-4" label="Data do envio" :disabled="readonly" v-model="form.data" ref="data" required type="date"/>
        <input-text class="col-12 col-md-4" label="Versão XML" :disabled="readonly" v-model="form.versao" ref="versao" required/>
        <div class="col-12 col-md-2">
            <span class="text-muted">Resultado</span><br>
            <b-badge :variant="resultado.variante" class="mt-2">{{resultado.text}}</b-badge>
        </div>
        <div class="col-12 col-md-2">
            <span class="text-muted">Conceito</span><br>
            <b-badge :variant="conceito.variante" class="mt-2">{{conceito.text}}</b-badge>
        </div>
        <input-mask class="col-12 col-md-6" mask="#.#" label="Nota" v-model="form.nota" ref="nota" required/>

        <div class="col-12 col-md-6 pr-4" v-if="form.nota < 3 && form.nota">
            <span class="text-muted">Percentual de glosa</span>
            <b-progress height="25px" style="width:98%" class=" mt-2" :max="100">
                <template v-for="i in 10" >
                    <b-progress-bar style="cursor: pointer;" @click.native="adicionarPercentual(i*10)" :key="i" :value="10" :class="`${i < 10 ? 'mr-1' : ''}`" :variant="form.percentual >= (i*10) ? 'info' : 'secondary'">{{i}}0%</b-progress-bar>
                </template>
            </b-progress>
        </div>  

        <div class="col-12 mb-2">
            <upload 
                id="annel12"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".*"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivoAWS = nomeArquivo;
                    form.conteudoBase64 = file;
                }" />
        </div>   
        <div class="col-12" v-if="!readonly">
            <b-button variant="success" v-if="permissao.c" @click="salvar">
                <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                Upload comprovante
            </b-button>
        </div>     
        <div class="col-12 mt-3">
            <h6>Lista de comprovantes</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', data.item)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import InputMask from '@/components/inputs/InputMask';
import Upload from '@/components/upload/Upload';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
export default {
    name: "Annel12",
    mixins: [FormMixin, AlertasMixin],
    components: {
        InputDateTime,
        Upload,
        InputText,
        InputMask,
    },   
    props: {
        itens : {
            
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        form : {
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Comprovante',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null,
            nota : null,
            percentual : null,
        },
        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão XML"},
                { key: "data", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },
        options : {
            percentual : [
                {text: "10%", value: 10},
                {text: "20%", value: 20},
                {text: "30%", value: 30},
                {text: "40%", value: 40},
                {text: "50%", value: 50},
                {text: "60%", value: 60},
                {text: "70%", value: 70},
                {text: "80%", value: 80},
                {text: "90%", value: 90},
                {text: "100%", value: 100},
            ],
            simnao : [
                {
                    value : 'S',
                    text : "Sim"
                },
                {
                    value : 'N',
                    text : "Não"
                }
            ]
        }
    }),    
    methods: {
        adicionarPercentual(percentual) {
            if(this.readonly)
                return;

            if(this.form.percentual == percentual)
                this.form.percentual = 0;
            else
                this.form.percentual = percentual;
        },
        salvar() {
            
            if( isNaN(parseFloat(this.form.nota))){
                this.alertaErro("Nota inválida");
                return;
            }
            
            if(parseFloat(this.form.nota) > 5 || parseFloat(this.form.nota) < 1) {
                this.alertaErro("Nota deve ser menor que 5 e maior ou igual a 1!");
                return;
            }
            this.$emit('salvar',this.form)
        }
    },
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento' || !this.projetoEditavel
        },
        resultado : function(){
            if(this.form.nota < 3) {
                return {text : "Reprovado", variante : "danger"};
            }else{
                return {text : "Aprovado", variante : "success"};
            }
        },
        conceito : function(){
            if(this.form.nota < 2) {
                return {text : "Inadequado", variante : "danger"};
            }
            if(this.form.nota < 3) {
                return {text : "Insuficiente", variante : "warning"};
            }
            if(this.form.nota < 3.5) {
                return {text : "Aceitável", variante : "primary"};
            }
            if(this.form.nota < 4.5) {
                return {text : "Bom", variante : "info"};
            }
            return {text : "Excelente", variante : "success"};

        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>